// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import CustomBanner from '../CustomBanner/CustomBanner';
import Slider from 'react-slick/lib';

import iphone14 from '../../../../assets/img/home/banner-carousel/new-banner/iPhone14.png';
import iphone15 from '../../../../assets/img/home/banner-carousel/new-banner/iPhone15.png';
import iphone16 from '../../../../assets/img/home/banner-carousel/new-banner/iPhone16.png';
// import primeDay2023 from '../../../../assets/img/home/banner-carousel/new-banner/prime-day-2023.png';
import blackFriday from '../../../../assets/img/home/banner-carousel/new-banner/black-friday-2022.png';
// import iphone12 from '../../../../assets/img/home/banner-carousel/new-banner/iphone12.png';
// import textIphone12 from '../../../../assets/img/home/banner-carousel/new-banner/text-iphone12.png';
import appleProducts from '../../../../assets/img/home/banner-carousel/new-banner/apple-products.png';
import qempoFlash from '../../../../assets/img/home/banner-carousel/new-banner/qempo-flash.png';
import cuotasProducts from '../../../../assets/img/home/banner-carousel/new-banner/cuotas-products.png';
// import textCuotasProducts from '../../../../assets/img/home/banner-carousel/new-banner/text-cuotas-products.png';
import textCuotasBCPProducts from '../../../../assets/img/home/banner-carousel/new-banner/text-cuotas-bcp-products.png';
import primeDay from '../../../../assets/img/home/banner-carousel/new-banner/prime-day.png';

import style from './BannerCarousel.scss';
import buttonStyle from '../../../../assets/styles/button.scss';

const bannerList = [
  /*{
    button: {
      text: 'Ver todo',
      position: 'right',
      color: 'lightBlue',
      to: 'https://www.qempo.com.pe/black-friday-2022'
    },
    background: '#1c1c1c',
    sideImage: {
      image: blackFriday,
      position: 'left'
    },
    right: (
      <div className={style.blackFriday}>
        <span><strong>¡Solo por hoy!</strong> Las mejores <br/> <strong>ofertas del año</strong> de USA a Perú.</span>
      </div>
    ),
    direction: 'normal'
  },*/
  /*{
    button: {
      text: 'Ver ofertas',
      position: 'left',
      color: 'gunmetal',
      to: 'https://help.qempo.com/article/h5zic8kuwr-ofertas-amazon-prime-day-2023-qempo'
    },
    background: '#a1f0c3',
    sideImage: {
      image: primeDay2023,
      position: 'right'
    },
    left: (
      <div className={style.textIphone14}>
        <span>¡Hoy! <strong>Amazon Prime Day</strong> 2023 <br/>
          Las mejores ofertas del año</span>
      </div>
    ),
    direction: 'normal'
  },*/
  /*{
    button: {
      text: 'Cotizar GRATIS',
      position: 'left',
      color: 'lightBlue',
      to: 'https://www.qempo.com.pe/custom-product/iphone-14?utm_source=Web&utm_medium=home&utm_campaign=home_banner_iphone_14'
    },
    background: '#f4f4f7',
    sideImage: {
      image: iphone14,
      position: 'right'
    },
    left: (
        <div className={style.textIphone14}>
          <span>Tu nuevo <strong>iPhone 14</strong> sin trámites, sin aduanas y
            <strong> sin impuestos.</strong>
          </span>
        </div>
    ),
    direction: 'normal'
  },*/
  /*{
    button: {
      text: 'Cotizar GRATIS',
      position: 'left',
      color: 'cream',
      to: 'https://www.qempo.com.pe/custom-product/iphone-15?utm_source=Web&utm_medium=home&utm_campaign=home_banner_iphone_15'
    },
    background: '#000',
    sideImage: {
      image: iphone15,
      position: 'right'
    },
    left: (
      <div className={style.textIphone15}>
          <span>Tu nuevo <strong>iPhone 15 sin impuestos</strong> con nuestros
            <strong> viajeros verificados</strong>
          </span>
      </div>
    ),
    direction: 'normal'
  },*/
  {
    button: {
      text: 'Cotizar GRATIS',
      position: 'left',
      color: 'ultramarine',
      to: 'https://www.qempo.com.pe/custom-product/iphone-16?utm_source=Web&utm_medium=home&utm_campaign=home_banner_iphone_16'
    },
    background: '#3d4999',
    sideImage: {
      image: iphone16,
      position: 'right'
    },
    left: (
      <div className={style.textIphone16}>
          <span>Tu nuevo <strong>iPhone 16 sin impuestos</strong> con nuestros
            <strong> viajeros verificados</strong>
          </span>
      </div>
    ),
    direction: 'normal'
  },
  {
    button: {
      text: 'Ver productos',
      position: 'right',
      color: 'red',
      to: '/apple'
    },
    background: 'linear-gradient(to bottom, #E4D6F0, #E6EFFE)',
    sideImage: {
      image: appleProducts,
      position: 'left'
    },
    right: (
      <div className={style.appleProducts}>
        <p>Los mejores productos Apple</p>
        <div>
          <span> De USA a Perú</span><p>sin trámites</p>
        </div>
      </div>
    ),
    direction: 'reverse'
  },
  {
    background: '#F69020',
    sideImage: {
      image: cuotasProducts,
      position: 'right'
    },
    left: <img className={style.textInformationImage} src={textCuotasBCPProducts} alt="image"/>,
    direction: 'normal'
  },
  /*{
    button: {
      text: 'Ver productos',
      position: 'right',
      color: 'orange',
      to: 'https://flash.qempo.com/'
    },
    background: '#0785F3',
    sideImage: {
      image: qempoFlash,
      position: 'left'
    },
    right: <div className={style.qempoFlash}><p>Productos de USA a tu casa</p><span>¡en 15 días!</span></div>,
    direction: 'reverse'
  },*/
];

export default function BannerCarousel() {
  const options = {
    infinite: true,
    slidesToScroll: 1,
    dots: true,
    dotsClass: classNames('slick-dots', style.dots),
    arrows: false,
    draggable: true,
    autoplaySpeed: 10000,
    autoplay: true,
    speed: 800,
    slidesToShow: 1,
  };

  const sliderList = bannerList.map((banner, index) => {
    return (<div
      key={`custom-slider-${index}`}>
      <CustomBanner
        positionButton={banner.button && banner.button.position}
        button={banner.button && (
          <a className={classNames(
            buttonStyle.btn,
            buttonStyle[banner.button.color],
            style.button
          )}
            href={banner.button.to}
            target="_blank">
            {banner.button.text}
          </a>
        )}
        background= {banner.background}
        left= {(banner: any).left}
        right={(banner: any).right}
        sideImage=  {banner.sideImage}
        direction = {banner.direction}
      />
    </div>);
  });

  return (
      <div className={style.bannerCarouselWrap}>
        <Slider {...options}>
          {sliderList}
        </Slider>
      </div>
  );
}



// WEBPACK FOOTER //
// ./src/modules/home/elements/BannerCarousel/BannerCarousel.jsx